import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import devLog from '../utils/devLog';

/**
 * ScrollToTop component - ensures page navigations start at the top
 * CRITICAL EXCEPTION: Does NOT auto-scroll on /result pages
 * Result pages must load at natural top position without forced scrolling
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // CRITICAL FIX: Exclude /result route from auto-scroll
    // Result pages (Bug Fix, New Project) must load at natural top
    // without forced scrolling to prevent disruptive auto-scroll behavior
    if (pathname.startsWith('/result')) {
      devLog.log('[ScrollToTop] Skipping auto-scroll for /result page');
      return;
    }
    
    // For all other routes: Scroll to top immediately on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Also reset document scroll position
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    devLog.log('[ScrollToTop] Auto-scroll to top for:', pathname);
  }, [pathname]);

  return null;
}
